var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.563994421,0.748907399 L0.651471863,0.651471863 C1.08885907,0.214084656 1.77988667,0.184925509 2.2510926,0.563994421 L2.34852814,0.651471863 L11,9.303 L19.6514719,0.651471863 C20.0888591,0.214084656 20.7798867,0.184925509 21.2510926,0.563994421 L21.3485281,0.651471863 C21.7859153,1.08885907 21.8150745,1.77988667 21.4360056,2.2510926 L21.3485281,2.34852814 L12.697,11 L21.3485281,19.6514719 C21.7859153,20.0888591 21.8150745,20.7798867 21.4360056,21.2510926 L21.3485281,21.3485281 C20.9111409,21.7859153 20.2201133,21.8150745 19.7489074,21.4360056 L19.6514719,21.3485281 L11,12.697 L2.34852814,21.3485281 C1.91114093,21.7859153 1.22011333,21.8150745 0.748907399,21.4360056 L0.651471863,21.3485281 C0.214084656,20.9111409 0.184925509,20.2201133 0.563994421,19.7489074 L0.651471863,19.6514719 L9.303,11 L0.651471863,2.34852814 C0.214084656,1.91114093 0.184925509,1.22011333 0.563994421,0.748907399 L0.651471863,0.651471863 L0.563994421,0.748907399 Z",
    fill: "currentColor",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.ea1e2dca7e610df4a41347bed78751ed.svg";
export { ForwardRef as ReactComponent };